import { IServiceproduct, IServiceproductMap } from "@iloq/shared/IProduct";

export function getServiceProductIds(
  serviceProducts: IServiceproductMap | null | undefined,
): string[] {
  if (!serviceProducts) {
    return [];
  }
  return [
    ...new Set(
      Object.values(serviceProducts).flatMap((service) =>
        service.products.map((product) => product.id),
      ),
    ),
  ];
}

export function hasServiceProducts(
  serviceProducts: IServiceproductMap | null | undefined,
): boolean {
  if (!serviceProducts) {
    return false;
  }
  return Object.values(serviceProducts).some(
    (service) => service.products.length > 0,
  );
}

export function findServiceProductById(
  serviceProductsMap: IServiceproductMap | null | undefined,
  productId: string,
): IServiceproduct | undefined {
  if (!serviceProductsMap) {
    return undefined;
  }
  return Object.values(serviceProductsMap)
    .flatMap((service) => service.products)
    .find((product) => product.id === productId);
}
